import Midas1 from '../../../static/projects-images/Midas/1.png';
import Midas2 from '../../../static/projects-images/Midas/2.png';
import Midas3 from '../../../static/projects-images/Midas/3.png';
import Midas4 from '../../../static/projects-images/Midas/4.png';
import Midas5 from '../../../static/projects-images/Midas/5.png';
import Midas6 from '../../../static/projects-images/Midas/6.png';
import Midas7 from '../../../static/projects-images/Midas/7.png';

import Planner1 from '../../../static/projects-images/Planner/1.png';
import Planner2 from '../../../static/projects-images/Planner/2.png';
import Planner3 from '../../../static/projects-images/Planner/3.png';
import Planner4 from '../../../static/projects-images/Planner/4.png';
import Planner5 from '../../../static/projects-images/Planner/5.png';
import Planner6 from '../../../static/projects-images/Planner/6.png';
import Planner7 from '../../../static/projects-images/Planner/7.png';

import React, { useState, useMemo } from "react";
import { Modal } from 'react-bootstrap';

import { useSwipeable } from 'react-swipeable'

import { ChevronRight, ChevronLeft, X, Image, GitHub } from 'react-feather';

import styles from './projects.module.css';

export const projects = [
    {
        title: 'Personal website',
        description: 'This website.',
        tags: ['Gatsby', 'JavaScript', 'Bootstrap'],
        images: [],
        github: undefined
    }
    , {
        title: 'Midas',
        description: 'Advanced expanses manager.',
        tags: ['PWA', 'Angular', 'TypeScript', 'Firebase', 'Bootstrap'],
        images: [Midas1, Midas2, Midas3, Midas4, Midas5, Midas6, Midas7],
        github: undefined
    }
    , {
        title: 'Planner',
        description: 'Reservations planner made for freelancers.',
        tags: ['PWA', 'React', 'TypeScript', 'Firebase', 'Bootstrap'],
        images: [Planner1, Planner2, Planner3, Planner4, Planner5, Planner6, Planner7],
        github: undefined
    }
    // , {
    //     title: 'Commit factory',
    //     description: 'Simple commit message maker.',
    //     tags: ['Angular', 'TypeScript', 'MongoDB', 'Bootstrap', ".NET Core"],
    //     images: [Planner1, Planner2, Planner3, Planner4, Planner5, Planner6, Planner7],
    //     github: 'https://github.com/LucaCastellaro/CommitFactory'
    // }
];

const Projects = () => {
    const [showModal, SetShowModal] = useState(false);
    const [currentProject, SetCurrentProject] = useState(undefined);
    const [currentImageIndex, SetCurrentImageIndex] = useState(0);

    const swipeActions = useSwipeable({
        onSwipedLeft: () => NextImage(),
        onSwipedRight: () => PreviousImage(),
        onSwipedUp: () => SetShowModal(false)
    });

    const ShowModal = useMemo(() => (project) => {
        SetCurrentProject(project);
        SetCurrentImageIndex(0)
        SetShowModal(true);
    }, []);

    const PreviousImage = useMemo(() => () => {
        if (currentImageIndex > 0)
            SetCurrentImageIndex(currentImageIndex - 1);
    }, [currentImageIndex]);

    const NextImage = useMemo(() => () => {
        if (currentImageIndex < (currentProject.images.length - 1))
            SetCurrentImageIndex(currentImageIndex + 1);
    }, [currentImageIndex, currentProject]);

    return (
        <div className="row align-content-center-horizontal vertical-breath" style={{ marginTop: '1em' }}>
            <div className="col-md-11 col-12">
                <h2>Projects</h2>
                <div className={`row ${styles.contentSpaceBetween} ${styles.noMargin}`}>
                    {
                        projects
                            .map((project, index) => {
                                return (
                                    <div className="card col-lg-5 col-12" {...{
                                        key: index,
                                        style: { marginTop: '1em' }
                                    }}>
                                        <div className="card-body">
                                            <h3 className={`card-title flex ${styles.contentSpaceBetween}`}>
                                                <span>{project.title}</span>
                                                <span>
                                                    {
                                                        project.github &&
                                                        <button className="btn btn-light"
                                                            {...{
                                                                title: project.title + ' GitHub repository.',
                                                                onClick: () => window.open(project.github, "_self"),
                                                                style: { marginRight: '10px' }
                                                            }}>
                                                            <GitHub />
                                                        </button>
                                                    }
                                                    {
                                                        project.images.length > 0 &&
                                                        <button className="btn btn-light"
                                                            title="Gallery"
                                                            onClick={() => ShowModal(project)}>
                                                            <Image />
                                                        </button>
                                                    }
                                                </span>
                                            </h3>
                                            <h6 className="card-subtitle mb-2 text-muted">{project.description}</h6>
                                            <p>{
                                                project.tags
                                                    .map((tag, index) => {
                                                        return (
                                                            <span key={index} className={styles.tag}>
                                                                {tag}
                                                            </span>
                                                        );
                                                    })
                                            }</p>
                                        </div>
                                    </div>
                                );
                            })
                    }
                </div>
            </div>
            {
                currentProject &&
                currentImageIndex >= 0 &&
                currentImageIndex < currentProject.images.length &&
                <Modal centered size="lg" {...{
                    show: showModal,
                    onHide: () => SetShowModal(false)
                }} >
                    <Modal.Header className={`flex ${styles.contentSpaceBetween}`}>
                        <Modal.Title>
                            {currentProject.title}
                        </Modal.Title>

                        <button className="btn btn-light"
                            title="Close"
                            onClick={() => SetShowModal(false)}>
                            <X />
                        </button>
                    </Modal.Header>
                    <Modal.Body className={`flex ${styles.contentSpaceBetween}`}>

                        <button className="btn btn-light d-none d-md-block"
                            title="Previous"
                            {...{
                                onClick: () => SetCurrentImageIndex(currentImageIndex - 1),
                                disabled: currentImageIndex === 0
                            }}>
                            <ChevronLeft />
                        </button>

                        <img className="rounded" {...{
                            ...swipeActions,
                            src: currentProject.images[currentImageIndex],
                            alt: currentProject.title,
                            style: {
                                justifySelf: 'center',
                                maxHeight: '70vh'
                            }
                        }} />

                        <button className="btn btn-light d-none d-md-block"
                            title="Next"
                            {...{
                                onClick: () => SetCurrentImageIndex(currentImageIndex + 1),
                                disabled: currentImageIndex === (currentProject.images.length - 1)
                            }}>
                            <ChevronRight />
                        </button>
                    </Modal.Body>
                    <Modal.Footer className="align-content-center-horizontal">
                        <p className="details">{(currentImageIndex + 1) + '/' + currentProject.images.length}</p>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    );
}

export default Projects;